export const PROJECT_CREATION_ERROR = {
  nonEnglishContent: 'CLIENT_NON_ENGLISH_CONTENT',
  notEnoughText: 'CLIENT_NOT_ENOUGH_TEXT',
  textUrlOrQuestions: 'CLIENT_TEXT_URL_OR_QUESTIONS',
  nonRelevantUrlOrQnaBrief: 'CLIENT_NON_RELEVANT_URL_OR_QNA_BRIEF',
  unsupportedLangManualBrief: 'CLIENT_UNSUPPORTED_LANG_MANUAL_BRIEF',
  clientDomainNotFound: 'CLIENT_DOMAIN_NOT_FOUND',
  unsupportedLangUrlBrief: 'CLIENT_UNSUPPORTED_LANG_URL_BRIEF',
} as const;
export type ProjectCreationErrorCode =
  (typeof PROJECT_CREATION_ERROR)[keyof typeof PROJECT_CREATION_ERROR];

export class ProjectCreationError extends Error {
  public code: ProjectCreationErrorCode;

  constructor(code: ProjectCreationErrorCode, message: string) {
    super(message);
    this.name = 'ProjectCreationError';
    this.code = code;
    this.message = message;
  }
}
